import { render, staticRenderFns } from "./MasterManagement.vue?vue&type=template&id=44a44200&scoped=true"
import script from "./MasterManagement.vue?vue&type=script&lang=ts"
export * from "./MasterManagement.vue?vue&type=script&lang=ts"
import style0 from "./MasterManagement.vue?vue&type=style&index=0&id=44a44200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a44200",
  null
  
)

export default component.exports